import { API_KEY_LABELS } from "./constants";

export const getApiPublicKeyLabel = (cexValue: string): string => {
  const apiKeyLabel = API_KEY_LABELS[cexValue];
  if (apiKeyLabel && apiKeyLabel.public) {
    return apiKeyLabel.public;
  }
  return "Public API Key";
};

export const getApiSecretKeyLabel = (cexValue: string): string => {
  const apiKeyLabel = API_KEY_LABELS[cexValue];
  if (apiKeyLabel && apiKeyLabel.secret) {
    return apiKeyLabel.secret;
  }
  return "Private API Key";
};
